import React, { useMemo } from 'react'
import { TreeSelect } from 'antd'

import "./select-tree.scss"

export interface SelectTreeNode {
  title: React.ReactNode
  value: string
  key?: string
  children?: SelectTreeNode[]
  selectable?: boolean
  disabled?: boolean;
}

interface SelectTreeProps {
  treeData: SelectTreeNode[]
  value?: string | undefined
  onChange?: (value: string | undefined) => void
  placeholder?: string
  className?: string
  style?: React.CSSProperties
  containerStyle?: React.CSSProperties
  allowClear?: boolean
}

export default function SelectTree({
  treeData,
  value,
  onChange,
  placeholder = 'Select',
  className,
  style,
  containerStyle,
  allowClear = true,
}: SelectTreeProps) {
  const expandedKeys = useMemo(() => {
    const keys: string[] = []
    const walk = (nodes: SelectTreeNode[]) => {
      nodes?.forEach((node) => {
        if (node.children && node.children.length > 0) {
          keys.push((node.key as string) || node.value)
          walk(node.children)
        }
      })
    }
    walk(treeData || [])
    return keys
  }, [treeData])

  const selectedParent = useMemo(() => {
    if (!value) return null
    const walk = (nodes: SelectTreeNode[]): string | null => {
      for (const node of nodes) {
        if (node.children) {
          const hasSelectedChild = node.children.some(child => child.value === value)
          if (hasSelectedChild) {
            if (typeof node.title === 'string') {
              return node.title
            } else if (React.isValidElement(node.title)) {
              const element = node.title as React.ReactElement
              if (element.props && element.props.children) {
                return typeof element.props.children === 'string' 
                  ? element.props.children 
                  : 'Category'
              }
            }
            return 'Category'
          }
          const result = walk(node.children)
          if (result) return result
        }
      }
      return null
    }
    return walk(treeData || [])
  }, [value, treeData])

  return (
    <div className="select-tree-container" style={containerStyle}>
      {selectedParent && (
        <div className="selected-parent-label">
          {selectedParent}
        </div>
      )}
      <TreeSelect
        treeData={treeData}
        value={value}
        onChange={onChange}
        style={style}
        placeholder={placeholder}
        allowClear={allowClear}
        treeDefaultExpandAll
        treeExpandedKeys={expandedKeys}
        onTreeExpand={() => {}}
        className={`${className} select-tree`}
        rootClassName='root-select-tree'
      />
    </div>
  )
}


